"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiggestStorage = void 0;
const core_1 = require("../core");
const indexedDB_1 = require("../store/indexedDB/indexedDB");
const constants_1 = require("./constants");
const storeAsync_1 = require("./storeAsync");
class BiggestStorage {
    constructor(options = {}) {
        this.storage = null;
        this.initDB = () => __awaiter(this, void 0, void 0, function* () {
            const isSupported = indexedDB_1.IndexedDb.isSupported();
            if (isSupported) {
                this.storage = new indexedDB_1.IndexedDb(this.options);
                core_1.Log.info('[BiggestStorage] - new IndexedDb - ' + JSON.stringify(this.options));
            }
            else {
                this.storage = new storeAsync_1.StoreAsync(Object.assign(Object.assign({}, this.options), {
                    storage: constants_1.StorageLocation.Local,
                }));
                core_1.Log.info('[BiggestStorage] - new StoreAsync - LocalStorage - ' + JSON.stringify(this.options));
            }
        });
        this.options = options;
    }
    getItem(key) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            core_1.Log.info(this.storage);
            if (!this.storage) {
                yield this.initDB();
            }
            return (_a = this.storage) === null || _a === void 0 ? void 0 : _a.getItem(key);
        });
    }
    setItem(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.storage) {
                yield this.initDB();
            }
            return (_a = this.storage) === null || _a === void 0 ? void 0 : _a.setItem(key, value);
        });
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.storage) {
                yield this.initDB();
            }
            return (_a = this.storage) === null || _a === void 0 ? void 0 : _a.clear();
        });
    }
    removeItem(key) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.storage) {
                yield this.initDB();
            }
            return (_a = this.storage) === null || _a === void 0 ? void 0 : _a.removeItem(key);
        });
    }
}
exports.BiggestStorage = BiggestStorage;
//# sourceMappingURL=biggestStorage.js.map